import { IUserUpdatePost } from '@/interfaces';
import UserService from '@/services/UserService';
import { useSessionStore } from '@/store/useSessionStore';
import { ref } from 'vue';

export default function useUser() {
  const { session } = useSessionStore()
  const submitting = ref(false)
  const updateUser = async (params: IUserUpdatePost, onSuccess: () => void) => {
    try {
      submitting.value = true
      await UserService.update(params)
      syncUser()
      onSuccess()
    } catch (error) {
      console.log(error)
    } finally {
      submitting.value = false
    }
  }
  const syncUser = () => {
    if (!session) return
    UserService.syncSession()
  }

  return {
    updateUser,
    submitting,
    syncUser
  };
}